﻿import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux'

//state
import {
    stopAction,
    setModalContentAction
} from '../../State/actions'

//components
import Option from '../Form/Option'
import Checkbox from '../Form/Checkbox'
import CheckboxMultiple from '../Form/CheckboxMultiple'
import Money from '../Form/Money'
import QuestionHeader from '../Wizard/QuestionHeader'
import QuestionWrapper from '../Wizard/QuestionWrapper'

const Question = ({
    index,
    headline,
    text,
    id,
    state,
    total,
    totalIndex,
    handleNext,
    currentChapterIndex,
    question,
    isLastQuestion,
    toggleShowAccount,
    togglePreSign,
    handleReset,
    ...props
}) => {

    const [currentAnswer, setCurrentAnswer] = useState('')

    const checkbox = question.questionType === 'Checkbox'
    const money = question.questionType === 'Money'
    const checkboxMultiple = question.questionType === 'CheckboxMultiple'
    const radio = question.questionType === 'Radio'

    let answered = currentAnswer !== ''
    let expectedAnswer = question.expectedAnswers
    let subQuestionGroup = question.subQuestionGroup


    // capture data to post back to api
    const {
        form: [formState, setFormState],
    } = {
        form: useState([]),
        ...(state || {}),
    };

    // handle answer
    const onAnswer = (answer, id, togglesSubQuestion) => {
        if (expectedAnswer) {
            checkExpectedAnswer(expectedAnswer, answer)
        } else {
            updateFormState(answer, id, togglesSubQuestion)
        }
    }

    const checkExpectedAnswer = (expectation, answer) => {
        if (expectation !== answer) {
            props.stop(true)
            props.setModalContent('STOP')
        } else {
            updateFormState(answer, id)
        }
    }

    // get the answer and id for post to api
    // if the answer toggles a subquestion (togglesSubQuestion === true), 
    // the wizard should stop and wait for further data
    const updateFormState = (answer, id, togglesSubQuestion) => {

        setFormState(formState => ({
            ...formState,
            Answers: [...formState.Answers, { Answer: answer, QuestionId: id }]
        }))

        if (togglesSubQuestion) {
            return
        } else {
            updateAnswer(answer)
        }
    }

    const updateAnswer = (answer) => {
        if (answer.includes('|')) {
            setCurrentAnswer(answer.replace(/\|(?=.|$)/g, ", "))
        } else {
            setCurrentAnswer(answer)
        }

        handleNext()

        if (isLastQuestion) {
            toggleShowAccount(true)
        }
    }

    // handle edit
    const onEdit = () => {
        handleReset(index, id, currentChapterIndex, isLastQuestion)
        setCurrentAnswer('')
    }

    return (
        <QuestionWrapper
            onAnswered={answered ? onEdit : undefined}
            question={question}
            index={index}
            tabIndex={`${answered ? -1 : 0}`}
            classes={`pension-wizard-block__question ${answered ? "answered" : ""}`}
        >
             {!answered &&
                    <QuestionHeader
                        id={id}
                        showCount={true}
                        headline={headline}
                        text={text}
                        index={index}
                        total={`${isLastQuestion ? total + 1 : total}`}
                    />
                }

                {answered &&
                      <QuestionHeader
                        showCount={true}
                        headline={headline}
                        text={text}
                        index={index}
                        total={`${isLastQuestion ? total + 1 : total}`}
                        answer={currentAnswer}
                    />
                }

                {!answered && radio && question.options && question.options.length > 0 &&
                    <div className="pension-wizard-block__question__card__options">
                            {question.options.map((option, i) => ( 
                                <Option
                                    key={i}
                                    option={option}
                                    subQuestionGroup={subQuestionGroup}
                                    togglesSubQuestion={option.togglesSubQuestionGroup}
                                    id={id}
                                    text={text}
                                    handleAnswer={onAnswer}
                                    handleNext={handleNext}
                                    setCurrentAnswer={setCurrentAnswer}
                                />
                            ))}
                    </div>
                }

                {!answered && checkbox && (
                    <Checkbox
                       handleAnswer={onAnswer}
                       id={id}
                    />
                )}

                 {!answered && money && (
                     <Money
                        buttonText="Nästa"
                        handleAnswer={onAnswer}
                        id={id}
                    />
                )}

                {!answered && checkboxMultiple && question.options && question.options.length > 0 && (
                     <CheckboxMultiple
                        options={question.options}
                        id={id}
                        handleAnswer={onAnswer}
                        setCurrentAnswer={setCurrentAnswer}
                        subQuestionGroup={subQuestionGroup}
                    />
                )}
            </QuestionWrapper>
      )
}

// state

const mapStateToProps = (state) => {
    return {
        stop: state.pensionWizardFlow.stop,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        stop: (payload) => dispatch(stopAction(payload)),
        setModalContent: (payload) => dispatch(setModalContentAction(payload)),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Question);

